import * as React from 'react';
import {doesLabelExist} from './helper';
import {getTagByPath} from '../../utils';

export const validateImageSrc = imgTag => {
  const regex = /"((https|http):)?(\/.*\.\w{3})"/g;
  let m = regex.exec(`${imgTag}`);
  let valid = false;
  while (m !== null) {
    if (m.index === regex.lastIndex) {
      regex.lastIndex++;
    }
    valid = true;
    m = regex.exec(`${imgTag}`);
  }
  return valid;
};

export const validateImageAltText = image => {

  if (image.indexOf('alt="') === -1) {
    image = image.replace('img', 'img alt=""');
  }

  return image;
};

export const validateContent = content => {
  const imgRegex = /<img([\w\W]+?)\/>/g;
  let imgResults = imgRegex.exec(content);

  while (imgResults !== null) {
    if (imgResults.index === imgRegex.lastIndex) {
      imgRegex.lastIndex++;
    }

    let image = imgResults[0].replace('http://', 'https://');
    const valid = validateImageSrc(image);

    image = validateImageAltText(image);

    if (!valid) {
      content = content.replace(image, '');
    } else {
      content = content.replace(imgResults[0], image);
    }
    imgResults = imgRegex.exec(content);
  }
  return content;
};

export const convertToHTML = content => {
  const cleanContent = validateContent(content);
  return <div data-hook="article-content" dangerouslySetInnerHTML={{__html: cleanContent}}/>;
};

export const getMonth = mounth => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return months[mounth].toLocaleUpperCase();
};

export const parseDate = timestamp => {
  const date = new Date(timestamp);
  return `${getMonth(date.getMonth())} ${date.getDate()}, ${date.getFullYear()}`;
};

export const transformToPath = name => {
  return `/${name.toLowerCase().replace(/ /g, '-')}`;
};

export const parseLabel = labels => {
  const links = [];
  labels.forEach(singleLabel => {
    if (singleLabel.name) {
      singleLabel.name = singleLabel.name.toLowerCase() === 'wix shoutout' ? 'Wix Promote' : singleLabel.name;
      links.push({name: singleLabel.name, path: transformToPath(singleLabel.name)});
    }
  });

  return links;
};

export const hasMedia = content => {
  return content && (content.indexOf('<img') !== -1 || content.indexOf('<iframe') !== -1);
};

type Article = {
  id: string;
  title: string;
  content: string;
  date: string;
  labels: any[];
  withMedia: boolean;
  basePath?: string;
};

export const parseArticle: (any) => Article = article => ({
  id: article.id,
  title: article.title,
  content: article.content,
  date: parseDate(article.creationDate),
  labels: article.labels ? parseLabel(article.labels) : [],
  withMedia: hasMedia(article.content),
});

export const validateLabels = (labels, experiments = []) => {
  const approvedLabels = [];
  for (let i = 0; i < labels.length; i++) {
    const label = labels[i];
    const path = getTagByPath(label.path, experiments);
    if (doesLabelExist(path)) {
      approvedLabels.push(label);
    }
  }
  return approvedLabels;
};

export const reFormatArticles = items => items.map(parseArticle);
export const decorateWithArticleUrl = items => items.map(
  item => ({...item, ...{path: `/article/${item.id}`}})
);
export const makeLinksOpenedInNewTab = items => items.map(
  item => ({...item, content: item.content.replace(/<a /g, '<a target="_blank" ')})
);
